import "./Blob.css";

const Blob = () => {
  return (
    <div className="blob">
      <span></span>
      <span></span>
    </div>
  );
};

export default Blob;
